import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { usePaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/hooks/usePaymentIntent';

// Refresh async all payment method detail entities in order to be able to display
// its conditions in EditCheckoutSessionCartStep.CONFIRM_NEW_AVAILABLE_PAYMENT_METHODS

export const useRefreshAllPaymentMethodDetailEntities = () => {
  const { refreshPaymentMethodEntity } = usePaymentIntent();

  const refreshAllPaymentMethodDetailEntities = async (
    paymentMethodDetailEntities?: PaymentMethodDetailEntity[],
  ): Promise<void> => {
    if (!paymentMethodDetailEntities) {
      throw new Error('Payment method detail entities not found in refreshAllPaymentMethodDetailEntities');
    }

    await Promise.all(
      paymentMethodDetailEntities.map(async (paymentMethodDetailEntity): Promise<void> => {
        if (paymentMethodDetailEntity && paymentMethodDetailEntity.isRefreshed === false) {
          try {
            await refreshPaymentMethodEntity(paymentMethodDetailEntity);
          } catch (error) {
            console.error('Error refreshing payment method detail entity', error);
          }
        }
      }),
    );
  };

  return {
    refreshAllPaymentMethodDetailEntities,
  };
};
